module.exports = __webpack_public_path__ + "static/media/js.c90ed54c.svg";